import { render } from "./Sale_Invoices.vue?vue&type=template&id=702f2001&scoped=true"
import script from "./Sale_Invoices.vue?vue&type=script&lang=js"
export * from "./Sale_Invoices.vue?vue&type=script&lang=js"

import "./Sale_Invoices.vue?vue&type=style&index=0&id=702f2001&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702f2001"]])

export default __exports__